/**
 * Parcels Details
 */

// React
import React, { FC, useContext, useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';

// Context
import AuthContext from '../../authContext';

//UI
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import theme from '../../theme';
import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  Collapse,
  DialogContent,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiAlertCircle,
  mdiArchiveOutline,
  mdiArrowRight,
  mdiBarcode,
  mdiCalendar,
  mdiCalendarClock,
  mdiCheck,
  mdiChevronDown,
  mdiChevronLeft,
  mdiChevronUp,
  mdiCityVariant,
  mdiClose,
  mdiCounter,
  mdiFormatListCheckbox,
  mdiKeyOutline,
  mdiMapMarkerOutline,
  mdiPackage,
  mdiPackageVariantClosed,
  mdiPhoneOutline,
  mdiPrinter,
  mdiStateMachine,
  mdiTextBoxSearch,
  mdiWarehouse,
} from '@mdi/js';

// Components
import ListParcelItems from './list';
import Can from '../../components/Can';
import Pagination from '@material-ui/lab/Pagination';
import Modal from '../../components/Modal';
import { useForm } from 'react-hook-form';

// Rules

// Helper
import { formaterPhoneNumber, translate } from '../../utils/helpers';
import jMoment from 'moment-jalaali';

// Type
import { Product, Props } from './interfaces';
import PaginationNumber from '../../components/PaginationNum';
import Client from 'client-sdk/src/client';
import { UpdateInventoryItemsRequestBuilder } from 'client-sdk/src/parcels/parcels';
import parcelsRepository from 'client-sdk/src/Repository/parcels-repository';
import inventoryItemsRepository from 'client-sdk/src/Repository/inventory-items-repository';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotfication.tsx';
import { mdiText } from '@mdi/js/commonjs/mdi';
import windowSize from '../../utils/hook/useWindowResize';
import { DetailsMobile } from '../parcelDetails/mobileView';
import DetailsMob from './indexMobile';


export type Input = {
  serial: string;
};

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    paper: {
      marginTop: '16px',
      marginBottom: '16px',
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      border: '1px solid #ddd',
      borderRadius: '4px',
    },
    allocateIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingTop: '10px',
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '.5',
        backgroundColor: '#f3ab3e',
      },
    },
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 500,
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    divider: {
      width: '98%',
      margin: '10px auto',
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '10px',
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '24px',
    },
    contentlabelTitle: {
      position: 'relative',
      color: theme.palette.gray.light,
      marginLeft: '40px',
      fontSize: '14px',
      fontWeight: 500,
      '&:before': {
        content: '"-"',
        position: 'absolute',
        left: '-20px',
      },
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    collapseIcon: {
      marginTop: '-36px',
      textAlign: 'center',
      position: 'relative',
      width: '100%',
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '40px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: theme.palette.secondary.main,
        border: '5px solid white',
      },
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    showCount: {
      '& .MuiSelect-icon': {
        color: '#DFA01F',
      },
    },
    card: {
      minWidth: '250px',
      display: 'flex',
      background: '#fff',
      padding: '8px 4px',
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    cardItem: {
      margin: '0 4px',
      flex: 1,
    },
  })
);

const Details: FC<Props> = (props: Props): React.ReactElement => {
  const history = useHistory();
  const [selected, setSelected] = React.useState<string[]>([]);
  const authContext = useContext(AuthContext);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const [openItemsNotFound, setOpenItemsNotFound] = useState(false as boolean);
  const [openBarcode, setOpenBarcode] = useState(false as boolean);
  const [checkBarcodeDialogClosed, setCheckBarcodeDialogClosed] = useState(
    false as boolean
  );
  const [openDeleteItem, setOpenDeleteItem] = React.useState(false);
  const [item, setItem] = useState({} as any);
  const [changeParcelStatusDialog, setChangeParcelStatusDialog] = useState(
    false as boolean
  );
  const [openDialogForChangeParcelStatus, setOpenDialogForChangeParcelStatus] =
    useState(false as boolean);
  const [openDialogForItemsNotUnloaded, setOpenDialogForItemsNotUnloaded] =
    useState(false as boolean);
  const [openUnloadItems, setOpenUnloadItems] = useState(false as boolean);
  const [statusChanged, setStatusChanged] = useState(false as boolean);
  const [id, setId] = useState(-1 as number);
  const [description, setDescription] = useState('');
  const [product, setProduct] = useState({} as Product);
  const { register, errors, handleSubmit, getValues, setValue, watch } =
    useForm<Input>({
      defaultValues: {
        serial: '',
      },
    });
  const [filtersValues, setFiltersValues] = useState({
    page: 0,
    size: 100,
  } as any);
  const [printModal, setPrintModal] = useState(false as boolean);
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const token = localStorage.getItem('token') || '';

  const [error, setError] = useState('');
  const [inventoryItemsError, setInventoryItemsError] = useState('');
  const [inventoryItemsWithSerialError, setInventoryItemsWithSerialError] =
    useState('');
  const [inventoryItemsWithStatusError, setInventoryItemsWithStatusError] =
    useState('');
  const [loading, setLoading] = useState(false);
  const [inventoryItemsLoading, setInventoryItemsLoading] = useState(false);
  const [inventoryItemsWithSerialLoading, setInventoryItemsWithSerialLoading] =
    useState(false);
  const [inventoryItemsWithStatusLoading, setInventoryItemsWithStatusLoading] =
    useState(false);
  const [parcel, setParcel] = useState({});
  const [parcelItems, setParcelItems] = useState([]);
  const [parcelItemsStatus, setParcelItemsStatus] = useState('');
  const [inventoryItems, setInventoryItems] = useState([]);
  const [inventoryItemsWithSerial, setInventoryItemsWithSerial] = useState([]);
  const [inventoryItemsWithStatus, setInventoryItemsWithStatus] = useState([]);
  const [inventoryItemsCount, setInventoryItemsCount] = useState(0);
  const [isMob, setIsMob] = useState(false);
  const { width } = windowSize();

  useEffect(() => {
    if (width && width <= 480) {
      setIsMob(true);
    } else {
      setIsMob(false);
    }
  }, [width]);

  const handleCollapse = () => {
    setOpen(!open);
  };

  const handleCloseSelect = () => {
    setOpenSize(false);
  };

  const handleDeleteInventoryItems = (item: any) => {
    setItem(item);
    setOpenDeleteItem(true);
  };

  const handleCloseDialog = () => {
    setOpenDeleteItem(false);
  };

  const handleCloseDialogForItemsNotUnloaded = () => {
    setOpenDialogForItemsNotUnloaded(false);
  };

  const handleCloseDialogForChangeParcelStatus = () => {
    const { id } = props.match.params;
    setOpenDialogForChangeParcelStatus(false);
  };

  const handleDialogForChangeParcelStatus = () => {
    const { id } = props.match.params;
    setOpenDialogForChangeParcelStatus(false);
    if (authContext.user.role === 'PARTNER_ADMIN') {
      history.push(`/parcels-sender/${id}/edit`);
    } else if (authContext.user.role === 'SELLER_ADMIN') {
      history.push(`/seller-parcels/${id}/edit`);
    }
  };

  const deleteInventoryItem = async () => {
    const { id } = props.match.params;
    const payload = {
      id: item.id,
      body: { description: description },
      callback: () => {
        getParcelWithId(id);
        setOpenDeleteItem(false);
      },
    };
    try {
      setLoading(true);
      const callback = await inventoryItemsRepository.unDeleteInventoryItems({
        payload,
      });
      handleNotfication(
        'وضعیت مغایرت آیتم مورد نظر با موفقیت تغییر کرد ',
        'success'
      );
      callback && callback();
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };

  const handleSetParcelStatusFunc = (status: string) => {
    handleSetParcelStatus(status);
  };
  const updateParcelsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await parcelsRepository.resolveParcelConflicts({
        payload,
      });
      handleNotfication('محموله با موفقیت به روز رسانی شد', 'success');
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };
  const handleSetParcelStatus = (status: string) => {
    if (status === 'ASSIGNED') setDescription('');
    updateParcelsStatus({
      id: props.match.params.id,
      pagination: {
        ...filtersValues,
      },
      callback: () => {
        setStatusChanged(!statusChanged);
        history.push('/parcels-sender');
      },
    });
    setOpenDialogForItemsNotUnloaded(false);
    setOpenDialogForChangeParcelStatus(false);
  };

  const handleOpenConfirmDisable = (item: Product, link = false) => {
    if (link) {
      if (item.status !== 'UNLOADED') {
        setStatusChanged(!statusChanged);
        handleSinglePrint(item)
          .then(_ => {
            const win = window.open(`${link}`, '_blank')!;
            win.focus();
          })
          .catch(err => {
          });
        return;
      }
      const win = window.open(`${link}`, '_blank')!;
      win.focus();
    } else {
      setId(item.id);
      setProduct(item);
    }
  };

  const getInventoryItemsWithSerial = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsWithSerialLoading(true);
      const { response, callback } =
        await inventoryItemsRepository.getInventoryItemsWithSerial(
          { payload },
          payload.callback
        );
      setInventoryItemsWithSerial(response.data.content);
      if (callback) {
        callback();
      }
      if (response.data.content.length === 0)
        handleNotfication('هیچ آیتمی پیدا نشد.', 'warn');
    } catch (error) {
      setInventoryItemsWithSerialError(error.message);
      handleError(error.response);
    } finally {
      setInventoryItemsWithSerialLoading(false);
    }
  };

  // const checkSerialFunc = async () => {
  //   await getInventoryItemsWithSerial({
  //     serialNumber: {equals: serial},
  //     parcelId: {equals: props.match.params.id},
  //   });
  // };
  const checkSerial = (data: any) => {
    getInventoryItemsWithSerial({
      ...filtersValues,
      serialNumber: { equals: data.serial },
      parcelId: { equals: props.match.params.id },
      status: { equals: 'DELETED_BY_OPERATOR' },
      callback: () => {
        setValue('serial', '');
      },
    });
  };

  const updateInventoryItemsStatus = async (action: any) => {
    const payload = { ...action };
    try {
      const callback = await inventoryItemsRepository.updateInventoryItems({
        payload,
      });
      handleNotfication('وضعیت آیتم مورد نظر با موفقیت تغییر کرد ', 'success');
      callback && callback();
    } catch (error) {
      handleError(error.response);
    }
  };

  const handleAllocateUserFunc = () => {
    const inventoryItem = product.id ? product : inventoryItemsWithSerial[0];
    updateInventoryItemsStatus({
      id: id !== -1 ? id : inventoryItemsWithSerial[0]?.id,
      body:
        inventoryItem.status !== 'UNLOADED' ? '"UNLOADED"' : '"NOT_UNLOADED"',
      ...filtersValues,
      callback: () => {
        setStatusChanged(!statusChanged);
      },
    });
    setOpenUnloadItems(false);
  };
  const getInventoryItemWithStatus = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsWithStatusLoading(true);
      const response =
        await inventoryItemsRepository.getInventoryItemsWithStatus({ payload });
      setInventoryItemsWithStatus(response.data.content);
      if (response.data.content.length !== 0) {
        setOpenDialogForChangeParcelStatus(true);
      }
    } catch (error) {
      setInventoryItemsWithStatusError(error.message);
      handleError(error.response);
    } finally {
      setInventoryItemsWithStatusLoading(false);
    }
  };

  const getInventoryItemsWithStatus = async () => {
    await getInventoryItemWithStatus({
      parcelId: { equals: props.match.params.id },
      status: { equals: 'DELETED_BY_OPERATOR' },
      ...filtersValues,
    });
  };

  const handleChangeParcelStatus = () => {
    if (inventoryItemsWithStatus.length !== 0) {
      setOpenDialogForChangeParcelStatus(true);
    }
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  // const handleSerial = (value: string) => {
  //   setSerial(value);
  // };

  // useEffect(() => {
  //   if (serial.length === 10) {
  //     setTimeout(() => {
  //       checkSerialFunc().then();
  //     }, 500);
  //   }
  // }, [serial]);
  const getParcelWithId = async (id: any) => {
    const payload = { id };
    try {
      setLoading(true);
      const response = await parcelsRepository.getParcelsWithId({ payload });
      setParcel(response.data);
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const getParcelInventoryItems = async (action: any) => {
    const payload = { ...action };
    try {
      setInventoryItemsLoading(true);
      const { response, callback } =
        await inventoryItemsRepository.getParcelInventoryItems({ payload });
      setInventoryItems(response.data.content);
      setInventoryItemsCount(response.data.totalElements);
      if (callback) {
        callback();
      }
    } catch (error) {
      setInventoryItemsError(error.message);
      handleError(error.response);
    } finally {
      setInventoryItemsLoading(false);
    }
  };
  useEffect(() => {
    const { page, size } = filtersValues;
    const { id } = props.match.params;
    getParcelWithId(id);
    getParcelInventoryItems({
      ...filtersValues,
      parcelId: { equals: id },
      status: { equals: 'DELETED_BY_OPERATOR' },
    });
  }, [statusChanged, filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    handleCloseBarcode(true);
  }, [inventoryItemsWithSerial]);

  /*  useEffect(() => {
    if (props.inventoryItemsWithSerial.length !== 0) {
      setSerial('');
      handleAllocateUserFunc();
    }
  }, [props.inventoryItemsWithSerial]);*/

  useEffect(() => {
    if (changeParcelStatusDialog) handleChangeParcelStatus();
  }, [inventoryItemsWithStatus]);

  useEffect(() => {
    if (parcel.id) {
      setParcelItems(parcel.items);
    }
  }, [parcel]);

  useEffect(() => {
    if (product.id) {
      handleAllocateUserFunc();
    }
  }, [product]);

  /*  useEffect(() => {
    if (props?.parcel?.status === 'UNLOADED') {
      setTimeout(() => {
        history.push('/parcels-warehouse-operator');
      }, 2000);
    }
  }, [props.parcel]);*/

  const handleClose = () => {
    setOpenUnloadItems(false);
  };

  const handleCloseItemsNotFound = () => {
    setOpenItemsNotFound(false);
  };

  const handleCloseBarcode = (setUnloaded: boolean) => {
    // setOpenBarcode(false);
    setValue('serial', '');
    if (setUnloaded && inventoryItemsWithSerial.length !== 0) {
      setId(-1);
      setProduct({} as Product);
      // setOpenUnloadItems(true);
      handleAllocateUserFunc();
    }
  };

  const handleClosePrintModal = () => {
    setPrintModal(false);
  };

  const handleOpenPrintModal = () => {
    setPrintModal(true);
  };

  const handleClick = (
    event: React.ChangeEvent<HTMLInputElement>,
    id: string
  ) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };

  const handleSinglePrint = async (item: Product) => {
    try {
      return await updateInventoryItemsStatus({
        id: item.id,
        body: '"UNLOADED"',
        ...filtersValues,
      });
    } catch (error) {
      throw error;
    }
  };

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelected = inventoryItems
        .filter((el: any) => el.status !== 'UNLOADED')
        .map((n: any) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };
  const unloadAllInventoryItems = async (ids: number[]) => {
    try {
      const request = new UpdateInventoryItemsRequestBuilder()
        .data({
          ids: ids,
        })
        .build();
      const client = new Client(token);
      await client.execute(request);
    } catch (err) {
      //err
    }
  };

  const updateMultiInventoryItemStatus = async (action: any) => {
    const payload = { ...action };
    try {
      setLoading(true);
      const response =
        await inventoryItemsRepository.updateMultiInventoryItemsStatus({
          payload,
        });
    } catch (error) {
      setError(error.message);
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  const handleClickPrint = () => {
    unloadAllInventoryItems(selected);
    props.history.push(
      `/print-labels/${props.match.params.id}?items=${selected.join(',')}`
    );
  };

  const handleChangePageNum = (pageNumber: number) => {
    setFiltersValues({ ...filtersValues, page: pageNumber });
  };

  const handleFilterStatus = (status: string) => {
    if (!status) {
      setParcelItems(parcel.items);
      setParcelItemsStatus(undefined);
      return;
    }
    if (parcelItemsStatus === status) {
      setParcelItemsStatus(undefined);
    } else {
      setParcelItemsStatus(status);
    }
    const newItems = parcelItems.filter((item: any) => item.status === status);
    setParcelItems(newItems);
  };
  
  return (
    (
      <div className={classes.root}>
        <div className={classes.headerBox}>
          <Typography variant="h6" component="h2">
            {`
        جزيیات محموله 
        ${parcel.destinationName}
        `}
          </Typography>
          <span className={classes.contentlabelTitle}>{parcel.id}</span>
        </div>

        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          <Button
            aria-label="details"
            size="medium"
            onClick={() => window.history.back()}
          >
            <Icon path={mdiArrowRight} size={1} className={classes.icon} />
            {'بازگشت'}
          </Button>

          <Can
            perform="parcel:inventory-items"
            role={authContext.user.role}
            yes={() => (
              <Link
                to={`/parcels/receipts/${parcel.id}`}
                target="_blank"
                style={{ textDecoration: 'none' }}
              >
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<Icon path={mdiPrinter} size={1} />}
                >
                  {'چاپ رسید'}
                </Button>
              </Link>
            )}
          />
        </Grid>
        <Paper elevation={3} className={classes.paper} variant="elevation" square>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={3}>
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon path={mdiCityVariant} size={1} className={classes.icon} />
                  {'نام شرکت:  '}
                </span>
                <span>{parcel.partnerName}</span>
              </div>
            </Grid>

            <Grid item xs={12} sm={3}>
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon path={mdiCounter} size={1} className={classes.icon} />
                  {'تعداد آیتم های محموله:  '}
                </span>

                <span>{inventoryItemsCount}</span>
              </div>
            </Grid>

            <Grid item xs={12} sm={3}>
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon path={mdiPackage} size={1} className={classes.icon} />
                  {'تعداد کارتن:  '}
                </span>

                <span>{parcel.boxCount}</span>
              </div>
            </Grid>

            <Grid item xs={12} sm={3}>
              <div className={classes.item}>
                <span className={classes.label}>
                  <Icon path={mdiCalendar} size={1} className={classes.icon} />
                  {'تاریخ تحویل به انبار:  '}
                </span>
                <span>
                  <span>
                    {parcel.shippingDate &&
                      `${jMoment(parcel.deliveryDate, 'YYYY/MM/DD')
                        .locale('fa')
                        .format('jYYYY/jMM/jDD')}`}
                  </span>
                </span>
              </div>
            </Grid>
            <Divider className={classes.divider} />
            <div className={classes.collapseIcon}>
              <IconButton onClick={handleCollapse}>
                <Icon
                  path={open ? mdiChevronUp : mdiChevronDown}
                  color="white"
                  size={1}
                />
              </IconButton>
            </div>

            <Collapse in={open} timeout="auto" unmountOnExit>
              <Grid style={{ margin: 0 }} xs={12} container spacing={3}>
                <Grid item xs={12} sm={3}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiAccountOutline}
                        size={1}
                        className={classes.icon}
                      />
                      {'نام مسئول حمل:  '}
                    </span>

                    <span>{parcel.agentName}</span>
                  </div>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiPhoneOutline}
                        size={1}
                        className={classes.icon}
                      />
                      {'شماره همراه مسئول حمل:  '}
                    </span>
                    <span>{formaterPhoneNumber(parcel.agentPhoneNumber)}</span>
                  </div>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiCalendar}
                        size={1}
                        className={classes.icon}
                      />
                      {'تاریخ ثبت محموله:  '}
                    </span>
                    <span>
                      <span>
                        {parcel.deliveryDate &&
                          `${jMoment(parcel.shippingDate, 'YYYY/MM/DD')
                            .locale('fa')
                            .format('jYYYY/jMM/jDD')}`}
                      </span>
                    </span>
                  </div>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiFormatListCheckbox}
                        size={1}
                        className={classes.icon}
                      />
                      {'نوع ارسال:  '}
                    </span>
                    <span>{translate(parcel.deliveryType)}</span>
                  </div>
                </Grid>

                <Divider className={classes.divider} />

                <Grid item xs={12} sm={3}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiKeyOutline}
                        size={1}
                        className={classes.icon}
                      />
                      {'شناسه محموله:  '}
                    </span>

                    <span>{parcel.id}</span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiWarehouse}
                        size={1}
                        className={classes.icon}
                      />
                      {'انبار مقصد:  '}
                    </span>

                    <span>{parcel.destinationName}</span>
                  </div>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiCalendarClock}
                        size={1}
                        className={classes.icon}
                      />
                      {'بازه تحویل محموله:  '}
                    </span>
                    <span>
                      <span>
                        {parcel.deliveryStartTime &&
                          jMoment(parcel.deliveryStartTime, 'hh:mm')
                            .locale('fa')
                            .format('HH:mm')}
                        {' - '}
                        {parcel.deliveryEndTime &&
                          jMoment(parcel.deliveryEndTime, 'hh:mm')
                            .locale('fa')
                            .format('HH:mm')}
                      </span>
                    </span>
                  </div>
                </Grid>

                <Grid item xs={12} sm={3}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiStateMachine}
                        size={1}
                        className={classes.icon}
                      />
                      {'وضعیت تحویل :  '}
                    </span>
                    <span>{translate(parcel.status, 'parcel')}</span>
                  </div>
                </Grid>
                <Divider className={classes.divider} />
                <Grid item xs={12}>
                  <div className={classes.item}>
                    <span className={classes.label}>
                      <Icon
                        path={mdiMapMarkerOutline}
                        size={1}
                        className={classes.icon}
                      />
                      {'آدرس انبار مقصد :  '}
                    </span>
                    <span>{parcel.destinationAddress}</span>
                  </div>
                </Grid>
              </Grid>
            </Collapse>
          </Grid>
        </Paper>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {inventoryItemsLoading ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              inventoryItems && (
                <ListParcelItems
                  deleteInventoryItem={(item: any) =>
                    handleDeleteInventoryItems(item)
                  }
                  parcelId={props.match.params.id}
                  operatorId={parcel.operatorId}
                  handleOpenConfirmDisable={handleOpenConfirmDisable}
                  data={inventoryItems}
                />
              )
            )}
          </Grid>
          <Grid id="showFilter" item xs={12} sm={6}>
            {inventoryItems && (
              <FormControl
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                  {' '}
                  تعداد نمایش در هر صفحه:
                </div>
                <Select
                  open={openSize}
                  onClose={handleCloseSelect}
                  className={classes.showCount}
                  onOpen={() => setOpenSize(true)}
                  value={filtersValues.size}
                  onChange={handleChangeSizePage}
                >
                  <MenuItem value={10}>10</MenuItem>
                  <MenuItem value={20}>20</MenuItem>
                  <MenuItem value={50}>50</MenuItem>
                  <MenuItem value={100}>100</MenuItem>
                </Select>
              </FormControl>
            )}
          </Grid>
          <Grid xs={12} sm={6} container item direction="row-reverse">
            {inventoryItems && (
              <>
                <Pagination
                  count={Math.ceil(inventoryItemsCount / filtersValues.size)}
                  color="secondary"
                  page={filtersValues.page + 1}
                  onChange={handleChangePage}
                />
                <PaginationNumber onChange={handleChangePageNum} />
              </>
            )}
          </Grid>
        </Grid>
        <Grid xs={12} style={{ marginTop: '30px' }} container justify="flex-end">
          <Button
            aria-label="unload-parcel"
            onClick={getInventoryItemsWithStatus}
            variant="contained"
            disabled={inventoryItems.length === 0}
            color="secondary"
          >
            <span className="">{'تایید مغایرت'}</span>
            <Icon path={mdiChevronLeft} size={1} />
          </Button>
        </Grid>
        <Dialog
          fullWidth
          open={openUnloadItems}
          onClose={handleClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle>
            <div
              style={{
                position: 'absolute',
                left: '17px',
                zIndex: 10,
              }}
            >
              {handleClose ? (
                <IconButton aria-label="close" onClick={handleClose}>
                  <Icon path={mdiClose} size={1} />
                </IconButton>
              ) : null}
            </div>
            <div className={classes.allocateIcon}>
              <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
            </div>
            <div>
              {id !== -1 || inventoryItemsWithSerial.length === 0 ? (
                <div>
                  {` از
            تغییر وضعیت کالا با شناسه
            "${id}"
            به
            "${product.status === 'UNLOADED' ? 'تخلیه نشده' : 'تخلیه شده'}"
          مطمئن هستید؟`}
                </div>
              ) : (
                <div>
                  <Grid
                    style={{ marginBottom: '15px' }}
                    container
                    alignItems="center"
                  >
                    <Grid item xs={12} sm={4}>
                      <div className={classes.item}>
                        <span className={classes.label}>
                          <Icon
                            path={mdiArchiveOutline}
                            size={1}
                            className={classes.icon}
                          />
                          {'نام کالا :  '}
                        </span>
                        <span>{inventoryItemsWithSerial[0]?.productName}</span>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <div className={classes.item}>
                        <span className={classes.label}>
                          <Icon
                            path={mdiKeyOutline}
                            size={1}
                            className={classes.icon}
                          />
                          {'شناسه کالا :  '}
                        </span>
                        <span>{inventoryItemsWithSerial[0]?.productId}</span>
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <div className={classes.item}>
                        <span className={classes.label}>
                          <Icon
                            path={mdiCounter}
                            size={1}
                            className={classes.icon}
                          />
                          {'تعداد :  '}
                        </span>
                        <span>{inventoryItemsWithSerial[0]?.amount}</span>
                      </div>
                    </Grid>
                  </Grid>
                  <div className={classes.cancelTitle}>
                    {` از
            تغییر وضعیت کالا با مشخصات بالا
            به تخلیه شده
          مطمئن هستید؟`}
                  </div>
                </div>
              )}
            </div>
          </DialogTitle>
          <DialogActions>
            <Grid container spacing={1}>
              <Grid item xs={8}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={handleClose}
                  variant="contained"
                  color="secondary"
                  size="large"
                >
                  {'خیر'}
                </Button>
              </Grid>

              <Grid item xs={4}>
                <Button
                  onClick={handleAllocateUserFunc}
                  fullWidth
                  variant="contained"
                  size="large"
                >
                  {'بله'}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>

        <Dialog open={openDeleteItem} onClose={handleCloseDialog}>
          <DialogContent style={{ width: '600px' }}>
            <div
              style={{
                position: 'absolute',
                left: '17px',
                zIndex: 10,
              }}
            >
              {handleCloseDialog ? (
                <IconButton
                  aria-label="close"
                  // className={classes.closeButton}
                  onClick={handleCloseDialog}
                >
                  <Icon path={mdiClose} size={1} />
                </IconButton>
              ) : null}
            </div>
            <div className={classes.cancelIcon}>
              <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
            </div>
            <p>
              ایا از حذف مغایرت اعلام شده برای آیتم انبار با شناسه
              <strong> {item.id} </strong>و با نام کالای{' '}
              <strong>"{item?.productName}"</strong> اطمینان دارید ؟
            </p>
            <Grid container item xs={12} alignItems="flex-end">
              <div className={classes.item} style={{ width: '100%' }}>
                <span className={classes.label}>
                  <Icon path={mdiText} size={1} className={classes.icon} />
                </span>

                <span style={{ width: '100%' }}>
                  <TextField
                    fullWidth
                    id="description"
                    name="description"
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    label="توضیحات"
                    className={classes.textInput}
                  />
                </span>
              </div>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Button
                  onClick={deleteInventoryItem}
                  variant="contained"
                  color="secondary"
                  size="large"
                  fullWidth
                  disabled={loading || !description}
                >
                  {`بله`}
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  onClick={handleCloseDialog}
                  variant="contained"
                  fullWidth
                  autoFocus
                >
                  {`خیر`}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>

        <Dialog
          fullWidth
          open={openDialogForChangeParcelStatus}
          onClose={handleCloseDialogForChangeParcelStatus}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle>
            <div
              style={{
                position: 'absolute',
                left: '17px',
                zIndex: 10,
              }}
            >
              {/*handleCloseDialogForChangeParcelStatus ? (
                <IconButton
                  aria-label="close"
                  onClick={handleCloseDialogForChangeParcelStatus}
                >
                  <Icon path={mdiClose} size={1} />
                </IconButton>
              ) : null */}
            </div>
            <div className={classes.editIcon}>
              <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
            </div>
            <div className={classes.cancelTitle}>
              {`حذف آیتم های اعلام شده را تایید میکنید ؟`}
            </div>
          </DialogTitle>
          <DialogActions>
            <Grid container spacing={1} alignItems='center' justifyContent='center'>
              <Grid item xs={6}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={e => handleSetParcelStatusFunc('ASSIGNED')}
                  variant="contained"
                  color="secondary"
                  size="large"
                >
                  {'بله'}
                </Button>
              </Grid>

              <Grid item xs={6}>
                <Button
                  onClick={handleCloseDialogForChangeParcelStatus}
                  fullWidth
                  variant="contained"
                  size="large"
                >
                  {'انصراف'}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
        <Dialog
          fullWidth
          open={openDialogForItemsNotUnloaded}
          onClose={handleCloseDialogForItemsNotUnloaded}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle>
            <div
              style={{
                position: 'absolute',
                left: '17px',
                zIndex: 10,
              }}
            >
              {handleCloseDialogForItemsNotUnloaded ? (
                <IconButton
                  aria-label="close"
                  // className={classes.closeButton}
                  onClick={handleCloseDialogForItemsNotUnloaded}
                >
                  <Icon path={mdiClose} size={1} />
                </IconButton>
              ) : null}
            </div>
            <div className={classes.allocateIcon}>
              <Icon path={mdiCheck} size={4} color={theme.palette.blue.main} />
            </div>
            <div className={classes.cancelTitle}>
              {inventoryItemsWithStatus.length > 1 ? (
                <div>
                  {`تعداد 
                "${inventoryItemsWithStatus.length}"
                آیتم از کالاها
                مانند آیتم با مشخصات 
              "${'نام کالا'} : ${inventoryItemsWithStatus[0]?.productName
                    }  - ${'شناسه کالا'} : ${inventoryItemsWithStatus[0]?.productId
                    }"
              هنوز تخلیه نشده است.`}
                </div>
              ) : (
                <div>
                  {`آیتم با شناسه 
                "${inventoryItemsWithStatus[0]?.id}"
                هنوز تخلیه نشده است.`}
                </div>
              )}
              <div>
                <Grid>
                  <TextField
                    fullWidth
                    id="description"
                    name="description"
                    autoFocus
                    rows={3}
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    label="توضیحات"
                  />
                </Grid>
              </div>
            </div>
          </DialogTitle>
          <DialogActions>
            <Grid container spacing={1}>
              <Grid item xs={8}>
                <Button
                  fullWidth
                  autoFocus
                  onClick={handleCloseDialogForItemsNotUnloaded}
                  variant="contained"
                  color="secondary"
                  size="large"
                >
                  {'بررسی مجدد'}
                </Button>
              </Grid>

              <Grid item xs={4}>
                <Button
                  onClick={e => handleSetParcelStatusFunc('CONFLICTED')}
                  fullWidth
                  variant="contained"
                  size="large"
                >
                  {'ایجاد مغایرت'}
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
        <Dialog
          fullWidth
          open={openItemsNotFound}
          onClose={handleCloseItemsNotFound}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle>
            <div
              style={{
                position: 'absolute',
                left: '17px',
                zIndex: 10,
              }}
            >
              {handleCloseItemsNotFound ? (
                <IconButton
                  aria-label="close"
                  // className={classes.closeButton}
                  onClick={handleCloseItemsNotFound}
                >
                  <Icon path={mdiClose} size={1} />
                </IconButton>
              ) : null}
            </div>
            <div className={classes.allocateIcon}>
              <Icon path={mdiAlertCircle} size={4} color="#faa320" />
            </div>
            <div className={classes.cancelTitle}>
              {`آیتم مورد نظر با سریال 
            " ${getValues().serial} "
            یافت نشد.`}
            </div>
          </DialogTitle>
          <DialogActions>
            <Grid container justify="flex-end">
              <Button
                autoFocus
                onClick={handleCloseItemsNotFound}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'باشه'}
              </Button>
            </Grid>
          </DialogActions>
        </Dialog>
        <Modal
          maxWidth="lg"
          onClose={() => setOpenBarcode(false)}
          open={openBarcode}
          title={
            <div>
              <Icon
                path={mdiPackageVariantClosed}
                size={4}
                color={theme.palette.green.main}
              />
            </div>
          }
          content={
            <form onSubmit={handleSubmit(checkSerial)}>
              <Grid container>
                <Grid xs={12}>
                  <div
                    style={{
                      width: '100%',
                      marginBottom: '30px',
                    }}
                  >
                    <TextField
                      fullWidth
                      autoFocus
                      id="serial"
                      name="serial"
                      label="سریال"
                      inputRef={register({ required: true })}
                      error={errors.serial && true}
                    />
                  </div>
                </Grid>
                <Grid xs={12} container justify="flex-end">
                  <Button
                    variant="contained"
                    color="secondary"
                    type="submit"
                    size="large"
                    startIcon={<Icon path={mdiTextBoxSearch} size={1} />}
                    disabled={watch('serial')?.length === 0}
                  >
                    {'یافتن کالا'}
                  </Button>
                </Grid>
              </Grid>
            </form>
          }
        />
      </div>
    )
  );
};

export default Details;
